/* oxlint-disable no-inner-declarations */
import * as rq from '@tanstack/react-query';

import { useDependencies } from '@/api/fe-api/contexts/dependencies.context';
import type { IDocumentRepository } from '@/modules/documents/domain/repositories/document.repository';

import { GetAllDocuments } from '../queries/get-all-documents';

export namespace UpdateDocument {
  export type Input = IDocumentRepository.UpdateInput;
  export type Output = IDocumentRepository.UpdateOutput;

  export function useMutation() {
    const queryClient = rq.useQueryClient();
    const { repositories } = useDependencies();

    return rq.useMutation<Output, unknown, Input>({
      mutationFn: (input) => repositories.document.update(input),
      async onSuccess(_, variables) {
        await Promise.all(
          variables.siteIds.map(async function (siteId) {
            await queryClient.invalidateQueries({
              queryKey: GetAllDocuments.key({ siteId }),
            });
          }),
        );
      },
    });
  }
}
